'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var IOSStatusBar = require('./IOSStatusBar');
var assetsHelper = require('../../helper/assetsHelper');
var appTypes = require('../../types/appTypes');
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');


/**
 * IPhone
 * @author mengxiaojiang
 * @createDate 2016-6-15
 */
var IPhone = React.createClass({
  render: function () {
    var direction = this.props.direction;
    var size = styleHelper.getSize(this.props);
    var move = 0;
    this.contentOrigRect = {
      left: 29.5,
      top: 87,
      right: 372,
      bottom: 609
    };
    if (direction === appTypes.Direction.HORIZONTAL) {
      move = (size.width - size.height) / 2;
    }
    return (
      <div className="component contents-layout component-IPhone">
        <div className="contents-layout">
          <img
            style={{
               width : direction === appTypes.Direction.VERTICAL?size.width:size.height,
               height : direction === appTypes.Direction.VERTICAL?size.height:size.width,
               pointerEvents:'none',
               transform : 'rotate('+(direction ===appTypes.Direction.HORIZONTAL?270:0)+'deg) translate(' + move + 'px,' + move + 'px)'
             }}
            ref="backgroundImg"
            src={assetsHelper.getAsset('components/wireframe/iphone.png')}
            onLoad={this.onImgLoaded}/>
        </div>
        <div ref="content" className="contents-layout">
          <div ref="statusBar" className="status-bar">
            <IOSStatusBar {...{ForegroundColor:'#FFF', color: '#000',IsAutoTextColor:false,h:20,w:'100%'}}/>
          </div>
          <div ref="bg" className="contents-layout">
            <div ref="top" className="top"/>
            <div ref="bottom" className="bottom"/>
          </div>
        </div>
      </div>
    );
  },

  onImgLoaded: function () {
    this.isLoaded = true;
    this.doAdjustChildBounds();
  },

  componentDidMount: function () {
    this.doAdjustChildBounds();
  },

  componentDidUpdate : function(){
    this.doAdjustChildBounds();
  },

  doAdjustChildBounds: function () {
    var contentDom;
    var size = styleHelper.getSize(this.props);
    var w = size.width;
    var h = size.height;
    var t;
    var contentRect;
    var scale;
    var sy;
    var imgW = 400;
    var imgH = 702;
    var _$;
    var showTop = false;
    var showBottom = false;
    var bgTop;
    var fullScreen = styleHelper.getPropertyValue(this.props,propConst.FULL_SCREEN);
    var phoneType = styleHelper.getPropertyValue(this.props,propConst.PHONE_TYPE);
    var isTransparent = styleHelper.getPropertyValue(this.props,propConst.IS_TRANSPARENT);
    if (!this.isLoaded) {
      return;
    }
    if (this.props.direction === appTypes.Direction.HORIZONTAL) {
      t = w;
      w = h;
      h = t;
    }
    scale = {
      x: w / imgW,
      y: h / imgH
    };

    contentRect = {
      left: this.contentOrigRect.left * scale.x,
      top: this.contentOrigRect.top * scale.y,
      right: this.contentOrigRect.right * scale.x,
      bottom: this.contentOrigRect.bottom * scale.y
    };
    sy = scale.y;
    if (this.props.direction === appTypes.Direction.HORIZONTAL) {
      sy = scale.x;
      contentRect = {
        left: contentRect.top,
        top: h - contentRect.right,
        right: contentRect.bottom,
        bottom: h - contentRect.left
      };

    }
    bgTop = 20 * sy;
    _$ = $(ReactDOM.findDOMNode(this.refs.content));
    _$.css({
      left: contentRect.left,
      top: contentRect.top,
      width: contentRect.right - contentRect.left,
      height: contentRect.bottom - contentRect.top
    });

    if (isTransparent) {
      _$.css({backgroundColor: 'rgba(0,0,0,0)'});
    } else {
      if (phoneType === appTypes.PhoneType.ALLBLACK) {
        _$.css({backgroundColor: 'rgba(0,0,0,0.5)'});
      } else {
        _$.css({backgroundColor: '#fff'});
      }
    }

    if (fullScreen) {
      _$ = $(ReactDOM.findDOMNode(this.refs.statusBar));
      _$.css({display: 'none'});
      _$ = $(ReactDOM.findDOMNode(this.refs.bg));
      _$.css({display: 'none'});
      showBottom = showTop = false;
    } else {
      $(ReactDOM.findDOMNode(this.refs.statusBar)).css({transform : 'scale(1,'+sy+')', 'transform-origin':'top',display:'block'});
      $(ReactDOM.findDOMNode(this.refs.bg)).css({top: bgTop, height: contentRect.bottom - contentRect.top - 20 * sy,display:'block'});
      showTop = phoneType === appTypes.PhoneType.TOPONLY || phoneType === appTypes.PhoneType.TOPANDBOTTOM;
      showBottom = phoneType === appTypes.PhoneType.TOPANDBOTTOM;
    }
    $(ReactDOM.findDOMNode(this.refs.top)).css({display: showTop ? 'block' : 'none',height : 40 * sy});
    $(ReactDOM.findDOMNode(this.refs.bottom)).css({display: showBottom ? 'block' : 'none',height : 40 * sy});
  }
});

module.exports = IPhone;



// WEBPACK FOOTER //
// ./src/views/Components/IPhone.jsx